import { ChartTypes } from 'containers/Report/Components/TypeBtn/TypeBtn';
import { Icons } from 'contents/icons';
import { DropDownListOptionType } from 'types/common/CommonType';
import {
  ALIGN_TYPE,
  CELL_MERGE_TYPE,
  DATA_LABEL_POSITION_TYPE,
  DATA_LABEL_TITLE_TYPE,
  IMAGE_FILL_TYPE,
  LEGEND_MARKER_TYPE,
  LEGEND_POSITION_TYPE,
  NUMBER_SCALE_TYPE,
  ORIENTATION_TYPE,
  POINT_HEAD_TYPE,
  RADAR_SHAPE_TYPE,
  RELATIVE_DATE_TYPE,
  SELECTOR_TYPE,
  STROKE_TYPE,
  SYMBOL_TYPE,
  TABLE_STYLE_APPLY_TYPE,
  UNIT_FORMAT_TYPE,
} from 'types/report/enum';
import { getTranslation } from 'utils/translation';

// LARGE DATA OPTION
const _LARGE_DATA_OPTION: any = {
  large: true,
  largeThreshold: 100000,
  progressive: 1000,
  progressiveThreshold: 100000,
  progressiveChunkMode: 'sequential',
};

const _DATA_LABEL_TITLE_TYPE_LIST: DropDownListOptionType[] = [
  {
    value: DATA_LABEL_TITLE_TYPE.NONE,
    get label() {
      return getTranslation('resource', 'NONE');
    },
  },
  {
    value: DATA_LABEL_TITLE_TYPE.CUSTOM,
    get label() {
      return getTranslation('resource', 'CUSTOM');
    },
  },
  {
    value: DATA_LABEL_TITLE_TYPE.SERIES,
    get label() {
      return getTranslation('resource', 'SERIES');
    },
  },
];

const _PIE_DATA_LABEL_POSITION_TYPE_LIST = [
  {
    key: DATA_LABEL_POSITION_TYPE.OUTSIDE,
    get tooltip() {
      return getTranslation('resource', 'OUTSIDE');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.INSIDE,
    get tooltip() {
      return getTranslation('resource', 'INSIDE');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.NONE,
    get tooltip() {
      return getTranslation('resource', 'NONE');
    },
  },
];

const _LINE_DATA_LABEL_POSITION_TYPE_LIST = [
  {
    key: DATA_LABEL_POSITION_TYPE.TOP,
    get tooltip() {
      return getTranslation('resource', 'TOP');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.BOTTOM,
    get tooltip() {
      return getTranslation('resource', 'BOTTOM');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.CENTER,
    get tooltip() {
      return getTranslation('resource', 'MIDDLE');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.ROTATE,
    get tooltip() {
      return getTranslation('resource', 'ROTATE');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.NONE,
    get tooltip() {
      return getTranslation('resource', 'NONE');
    },
  },
];

const _BAR_DATA_LABEL_POSITION_TYPE_LIST = [
  {
    key: DATA_LABEL_POSITION_TYPE.OUTSIDE,
    get tooltip() {
      return getTranslation('resource', 'OUTSIDE');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.TOP,
    get tooltip() {
      return getTranslation('resource', 'TOP');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.MIDDLE,
    get tooltip() {
      return getTranslation('resource', 'MIDDLE');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.BOTTOM,
    get tooltip() {
      return getTranslation('resource', 'BOTTOM');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.NONE,
    get tooltip() {
      return getTranslation('resource', 'NONE');
    },
  },
];

const _COMBO_DATA_LABEL_POSITION_TYPE_LIST = [
  {
    key: DATA_LABEL_POSITION_TYPE.OUTLINE,
    get tooltip() {
      return getTranslation('resource', 'OUTLINE');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.BOTTOM_TOP,
    get tooltip() {
      return getTranslation('resource', 'BOTTOM_TOP');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.CENTER_BOTTOM,
    get tooltip() {
      return getTranslation('resource', 'CENTER_BOTTOM');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.NONE,
    get tooltip() {
      return getTranslation('resource', 'NONE');
    },
  },
];

const _SUMMARY_DATA_LABEL_POSITION_TYPE_LIST = [
  {
    key: DATA_LABEL_POSITION_TYPE.TOP,
    get tooltip() {
      return getTranslation('resource', 'TOP');
    },
  },
  {
    key: DATA_LABEL_POSITION_TYPE.BOTTOM,
    get tooltip() {
      return getTranslation('resource', 'BOTTOM');
    },
  },
];

// LEGEND POSITION
const _LEGEND_POSITION_TYPE_LIST: DropDownListOptionType[] = [
  {
    label: getTranslation('resource', 'TOP'),
    value: LEGEND_POSITION_TYPE.TOP,
  },
  {
    label: getTranslation('resource', 'BOTTOM'),
    value: LEGEND_POSITION_TYPE.BOTTOM,
  },
  {
    label: getTranslation('resource', 'LEFT'),
    value: LEGEND_POSITION_TYPE.LEFT,
  },
  {
    label: getTranslation('resource', 'RIGHT'),
    value: LEGEND_POSITION_TYPE.RIGHT,
  },
  {
    label: getTranslation('resource', 'TOP_LEFT'),
    value: LEGEND_POSITION_TYPE.TOP_LEFT,
  },
  {
    label: getTranslation('resource', 'TOP_RIGHT'),
    value: LEGEND_POSITION_TYPE.TOP_RIGHT,
  },
  {
    label: getTranslation('resource', 'BOTTOM_LEFT'),
    value: LEGEND_POSITION_TYPE.BOTTOM_LEFT,
  },
  {
    label: getTranslation('resource', 'BOTTOM_RIGHT'),
    value: LEGEND_POSITION_TYPE.BOTTOM_RIGHT,
  },
];

// CONTEXT SELECTOR STYLE
const _SLICER_TYPE_LIST: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'HORIZONTAL_TILES');
    },
    value: SELECTOR_TYPE.HORIZONTAL_TILES,
  },
  // {
  //   get label() {
  //     return getTranslation('resource', 'DROPDOWN');
  //   },
  //   value: SELECTOR_TYPE.DROPDOWN,
  // },
  {
    get label() {
      return getTranslation('resource', 'MULTIPLE_DROPDOWN');
    },
    value: SELECTOR_TYPE.MULTIPLE_DROPDOWN,
  },
  {
    get label() {
      return getTranslation('resource', 'SINGLE_DROPDOWN');
    },
    value: SELECTOR_TYPE.SINGLE_DROPDOWN,
  },
  // {
  //   get label() {
  //     return getTranslation('resource', 'VERTICAL_LIST_RADIO');
  //   },
  //   value: SLICER_TYPE.VERTICAL_LIST_RADIO,
  // },
  {
    get label() {
      return getTranslation('resource', 'VERTICAL_LIST_CHECKBOX');
    },
    value: SELECTOR_TYPE.VERTICAL_LIST_CHECKBOX,
  },
  {
    get label() {
      return getTranslation('resource', 'RELATIVE_DATE');
    },
    value: SELECTOR_TYPE.RELATIVE_DATE,
  },
  // {
  //   get label() {
  //     return getTranslation('resource', 'SEARCH');
  //   },
  //   value: SELECTOR_TYPE.SEARCH,
  // },
  // {
  //   get label() {
  //     return getTranslation('resource', 'SLIDER')
  //   },
  //   value: SLICER_TYPE.SLIDER,
  // },
  {
    get label() {
      return getTranslation('resource', 'BETWEEN');
    },
    value: SELECTOR_TYPE.BETWEEN,
  },
];

// AGGREGATE
const _FIELD_AGGREGATE_TYPE = [
  {
    get label() {
      return getTranslation('resource', 'AVERAGE');
    },
    value: 'AVG',
  },
  {
    get label() {
      return getTranslation('resource', 'COUNT');
    },
    value: 'COUNT',
  },
  {
    get label() {
      return getTranslation('resource', 'MAX');
    },
    value: 'MAX',
  },
  {
    get label() {
      return getTranslation('resource', 'MIN');
    },
    value: 'MIN',
  },
  {
    get label() {
      return getTranslation('resource', 'SUM');
    },
    value: 'SUM',
  },
];

// ALIGN TYPE LIST
const _ALIGN_TYPE_LIST: {
  value: ALIGN_TYPE;
  icon: keyof typeof Icons;
  label?: string;
}[] = [
  {
    value: ALIGN_TYPE.LEFT,
    icon: 'AlignLeft03',
    get label() {
      return getTranslation('resource', 'HORIZONTAL');
    },
  },
  {
    value: ALIGN_TYPE.CENTER,
    icon: 'AlignHorizontalCentre03',
  },
  {
    value: ALIGN_TYPE.RIGHT,
    icon: 'AlignRight03',
  },
  {
    value: ALIGN_TYPE.TOP,
    icon: 'AlignTopArrow03',
    get label() {
      return getTranslation('resource', 'VERTICAL');
    },
  },
  {
    value: ALIGN_TYPE.MIDDLE,
    icon: 'AlignVerticalCenter03',
  },
  {
    value: ALIGN_TYPE.BOTTOM,
    icon: 'AlignBottom03',
  },
  {
    value: ALIGN_TYPE.HORIZONTAL_SPACING,
    icon: 'DistributeSpacingHorizontal',
    get label() {
      return getTranslation('resource', 'SPACING');
    },
  },
  {
    value: ALIGN_TYPE.VERTICAL_SPACING,
    icon: 'DistributeSpacingVertical',
  },
];

// SPACING TYPE LIST
const _SPACING_TYPE_LIST: {
  value: ALIGN_TYPE;
  icon: keyof typeof Icons;
  label?: string;
}[] = [
  {
    value: ALIGN_TYPE.HORIZONTAL_SPACING,
    icon: 'DistributeSpacingHorizontal',
    get label() {
      return getTranslation('resource', 'SPACING');
    },
  },
  {
    value: ALIGN_TYPE.VERTICAL_SPACING,
    icon: 'DistributeSpacingVertical',
  },
];

// GRADIENT TYPES
const _GRADIENT_TYPE_LIST: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'LINEAR');
    },
    value: 'linear',
  },
  {
    get label() {
      return getTranslation('resource', 'RADIAL');
    },
    value: 'radial',
  },
];

const _GRADIENT_ROTATE_TYPE_LIST: DropDownListOptionType[] = [
  { label: '0°', value: 0 },
  { label: '45°', value: 45 },
  { label: '90°', value: 90 },
  { label: '135°', value: 135 },
  { label: '180°', value: 180 },
  { label: '225°', value: 225 },
  { label: '270°', value: 270 },
  { label: '315°', value: 315 },
];

const _GRIDLINES_STROKE_TYPE_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'SOLID');
    },
    value: STROKE_TYPE.SOLID,
    icon: 'StrokeSolid',
  },
  {
    get label() {
      return getTranslation('resource', 'DASH');
    },
    value: STROKE_TYPE.DASHED,
    icon: 'StrokeDash',
  },
  {
    get label() {
      return getTranslation('resource', 'NONE');
    },
    value: STROKE_TYPE.NONE,
    icon: 'CoordinateX',
  },
];

// STROKE LINE TYPE
const _STROKE_TYPE_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'SOLID');
    },
    value: STROKE_TYPE.SOLID,
    icon: 'StrokeSolid',
  },
  {
    get label() {
      return getTranslation('resource', 'DASH');
    },
    value: STROKE_TYPE.DASHED,
    icon: 'StrokeDash',
  },
];

// STROKE HEAD
const _STROKE_HEAD_TYPE_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'NONE');
    },
    value: POINT_HEAD_TYPE.NONE,
    icon: 'ArrowNone',
  },
  {
    get label() {
      return getTranslation('resource', 'LINE_ARROW');
    },
    value: POINT_HEAD_TYPE.LINE_ARROW,
    icon: 'ArrowLine',
  },
  {
    get label() {
      return getTranslation('resource', 'TRIANGLE_ARROW');
    },
    value: POINT_HEAD_TYPE.TRIANGLE_ARROW,
    icon: 'ArrowTriangle',
  },
  {
    get label() {
      return getTranslation('resource', 'CIRCLE_ARROW');
    },
    value: POINT_HEAD_TYPE.CIRCLE_ARROW,
    icon: 'ArrowCircle',
  },
  {
    get label() {
      return getTranslation('resource', 'SQUARE_ARROW');
    },
    value: POINT_HEAD_TYPE.SQUARE_ARROW,
    icon: 'ArrowSquare',
  },
];

// Scatter Symbols
const _SCATTER_SYMBOL_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'CIRCLE');
    },
    value: SYMBOL_TYPE.CIRCLE,
  },
  {
    get label() {
      return getTranslation('resource', 'RECT');
    },
    value: SYMBOL_TYPE.ROUND_RECT,
  },
  {
    get label() {
      return getTranslation('resource', 'TRIANGLE');
    },
    value: SYMBOL_TYPE.TRIANGLE,
  },
  {
    get label() {
      return getTranslation('resource', 'DIAMOND');
    },
    value: SYMBOL_TYPE.DIAMOND,
  },
  {
    get label() {
      return getTranslation('resource', 'PIN');
    },
    value: SYMBOL_TYPE.PIN,
  },
  {
    get label() {
      return getTranslation('resource', 'ARROW');
    },
    value: SYMBOL_TYPE.ARROW,
  },
];

// Orientation
const _ORIENTATION_TYPE_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'VERTICAL');
    },
    value: ORIENTATION_TYPE.VERTICAL,
  },
  {
    get label() {
      return getTranslation('resource', 'HORIZONTAL');
    },
    value: ORIENTATION_TYPE.HORIZONTAL,
  },
];

// Shapes
const _SHAPE_TYPE_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'POLYGON');
    },
    value: RADAR_SHAPE_TYPE.POLYGON,
  },
  {
    get label() {
      return getTranslation('resource', 'CIRCLE');
    },
    value: RADAR_SHAPE_TYPE.CIRCLE,
  },
];

// Operators
const _OPERATOR_TYPE_OPTIONS: DropDownListOptionType[] = [
  { label: '=', value: 'EQ' },
  { label: '!=', value: 'NE' },
  { label: '>', value: 'GT' },
  { label: '>=', value: 'GTE' },
  { label: '<', value: 'LT' },
  { label: '<=', value: 'LTE' },
];

// CHART INFO LIST (변경 없음 - 번역 필드 없음)
const _CHART_INFO_LIST: Record<
  ChartTypes,
  {
    label?: { count: number; isOrMore: boolean };
    value?: { count: number; isOrMore: boolean };
  }
> = {
  CLUSTERED_COLUMN: {
    // label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  STACKED_COLUMN: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  STACKED_COLUMN_100: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  COMBO_CHART: {
    label: { count: 1, isOrMore: true },
    value: { count: 2, isOrMore: true },
  },
  CLUSTERED_BAR: {
    // label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  STACKED_BAR: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  STACKED_BAR_100: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  LINE: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  STACKED_LINE: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  STACKED_LINE_100: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  AREA: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  STACKED_AREA: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  STACKED_AREA_100: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  PIE_CHART: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  DOUGHNUT_CHART: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  ROSE_CHART: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  SUNBURST: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  SCATTER: {
    label: { count: 1, isOrMore: true },
    value: { count: 2, isOrMore: true },
  },
  TREEMAP: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  GAUGE: {
    value: { count: 1, isOrMore: false },
  },
  TABLE_CHART: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  MATRIC_TABLE: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  SUMMARY_CARD: {
    value: { count: 1, isOrMore: false },
  },
  FUNNEL_CHART: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  RADAR_CHART: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  GEO_CHART: {
    label: { count: 1, isOrMore: true },
    value: { count: 1, isOrMore: true },
  },
  CONTEXT_SELECTOR: {
    label: { count: 1, isOrMore: false },
  },
};

// Secondary Value Chart Types
const _HAS_SECONDARY_VALUE_CHART_TYPE = [
  'CLUSTERED_COLUMN',
  'CLUSTERED_BAR',
  'LINE',
  'AREA',
  'COMBO_CHART',
];

// No Legend Chart Types
const _NO_LEGEND_CHART_TYPE = [
  'TABLE_CHART',
  'MATRIC_TABLE',
  'SUMMARY_CARD',
  'GAUGE',
  'TREEMAP',
  'CONTEXT_SELECTOR',
];

const _PIE_CHART_TYPES = ['PIE_CHART', 'DOUGHNUT_CHART', 'ROSE_CHART', 'FUNNEL_CHART', 'SUNBURST'];
const _COLUMN_CHART_TYPES = ['CLUSTERED_COLUMN', 'STACKED_COLUMN', 'STACKED_COLUMN_100'];
const _BAR_CHART_TYPES = ['CLUSTERED_BAR', 'STACKED_BAR', 'STACKED_BAR_100'];
const _LINE_CHART_TYPES = [
  'LINE',
  'STACKED_LINE',
  'STACKED_LINE_100',
  'AREA',
  'STACKED_AREA',
  'STACKED_AREA_100',
];
const _OTHER_CHART_TYPES = ['RADAR_CHART', 'SCATTER'];
const _NO_DATA_LABEL_CHARTS = ['TABLE_CHART', 'SUMMARY_CARD', 'GAUGE'];

// Image Fill
const _IMAGE_FILL_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'FILL_IMAGE');
    },
    value: IMAGE_FILL_TYPE.FILL,
  },
  {
    get label() {
      return getTranslation('resource', 'FIT_IMAGE');
    },
    value: IMAGE_FILL_TYPE.FIT,
  },
  {
    get label() {
      return getTranslation('resource', 'CROP_IMAGE');
    },
    value: IMAGE_FILL_TYPE.COVER,
  },
];

const _LEGEND_MARKER_TYPE_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'CIRCLE');
    },
    value: LEGEND_MARKER_TYPE.CIRCLE,
  },
  {
    get label() {
      return getTranslation('resource', 'SQUARE');
    },
    value: LEGEND_MARKER_TYPE.SQUARE,
  },
  {
    get label() {
      return getTranslation('resource', 'LINE');
    },
    value: LEGEND_MARKER_TYPE.LINE,
  },
];

const _CHART_STYLE_APPLY_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'ALL');
    },
    value: 'ALL',
  },
  {
    get label() {
      return getTranslation('resource', 'MIN');
    },
    value: 'MIN',
  },
  {
    get label() {
      return getTranslation('resource', 'MAX');
    },
    value: 'MAX',
  },
];

const _LINE_TYPE_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'STRAIGHT_LINE');
    },
    value: 'STRAIGHT',
  },
  {
    get label() {
      return getTranslation('resource', 'CURVED_LINE');
    },
    value: 'CURVED',
  },
];

const _NUMBER_SCALE_TYPE_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'LABEL_AUTO');
    },
    value: NUMBER_SCALE_TYPE.AUTO,
  },
  {
    get label() {
      return getTranslation('resource', 'NONE');
    },
    value: NUMBER_SCALE_TYPE.NONE,
  },
  {
    get label() {
      return getTranslation('resource', 'THOUSANDS');
    },
    value: NUMBER_SCALE_TYPE.THOUSANDS,
  },
  {
    get label() {
      return getTranslation('resource', 'MILLIONS');
    },
    value: NUMBER_SCALE_TYPE.MILLIONS,
  },
  {
    get label() {
      return getTranslation('resource', 'BILLIONS');
    },
    value: NUMBER_SCALE_TYPE.BILLIONS,
  },
  {
    get label() {
      return getTranslation('resource', 'TRILLIONS');
    },
    value: NUMBER_SCALE_TYPE.TRILLIONS,
  },
];

const _UNIT_FORMAT_TYPE_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'LABEL_AUTO');
    },
    value: UNIT_FORMAT_TYPE.AUTO,
  },
  {
    get label() {
      return getTranslation('resource', 'PEOPLE');
    },
    value: UNIT_FORMAT_TYPE.PEOPLE,
  },
  {
    get label() {
      return getTranslation('resource', 'CASES');
    },
    value: UNIT_FORMAT_TYPE.CASES,
  },
  {
    get label() {
      return '%';
    },
    value: UNIT_FORMAT_TYPE.PERCENT,
  },
  {
    get label() {
      return getTranslation('resource', 'KRW');
    },
    value: UNIT_FORMAT_TYPE.KRW,
  },
  {
    get label() {
      return 'km';
    },
    value: UNIT_FORMAT_TYPE.KM,
  },
  {
    get label() {
      return 'ms';
    },
    value: UNIT_FORMAT_TYPE.MS,
  },
];

const _CELL_MERGE_TYPE_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'OFF');
    },
    value: CELL_MERGE_TYPE.OFF,
  },
  {
    get label() {
      return getTranslation('resource', 'SAME_VALUE');
    },
    value: CELL_MERGE_TYPE.SAME_VALUE,
  },
];

const _TABLE_STYLE_APPLY_OPTIONS: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'ALL');
    },
    value: 'ALL',
  },
  {
    get label() {
      return getTranslation('resource', 'HEADER');
    },
    value: TABLE_STYLE_APPLY_TYPE.HEADER,
  },
  {
    get label() {
      return getTranslation('resource', 'BODY');
    },
    value: TABLE_STYLE_APPLY_TYPE.BODY,
  },
];

const _RELATIVE_DATE_TYPE_OPTIONS: DropDownListOptionType<RELATIVE_DATE_TYPE | undefined>[] = [
  {
    get label() {
      return getTranslation('resource', 'ALL');
    },
    value: undefined,
  },
  {
    get label() {
      return getTranslation('resource', 'OPTION_TODAY');
    },
    value: RELATIVE_DATE_TYPE.TODAY,
  },
  {
    get label() {
      return getTranslation('resource', 'OPTION_YESTERDAY');
    },
    value: RELATIVE_DATE_TYPE.YESTERDAY,
  },
  {
    get label() {
      return getTranslation('resource', 'OPTION_LAST_7_DAYS');
    },
    value: RELATIVE_DATE_TYPE.LAST_7_DAYS,
  },
  {
    get label() {
      return getTranslation('resource', 'OPTION_LAST_30_DAYS');
    },
    value: RELATIVE_DATE_TYPE.LAST_30_DAYS,
  },
  {
    get label() {
      return getTranslation('resource', 'OPTION_THIS_MONTH');
    },
    value: RELATIVE_DATE_TYPE.THIS_MONTH,
  },
  {
    get label() {
      return getTranslation('resource', 'OPTION_LAST_MONTH');
    },
    value: RELATIVE_DATE_TYPE.LAST_MONTH,
  },
];

const _SELECTOR_ALL_VALUE = '__ALL__';

const _ALL_OPTION: DropDownListOptionType = {
  label: 'All',
  value: _SELECTOR_ALL_VALUE,
  treeKey: _SELECTOR_ALL_VALUE,
};

const _CHART_MIN_SIZE = 20;

// EXPORT WITH GETTERS
export default {
  get LARGE_DATA_OPTION() {
    return _LARGE_DATA_OPTION;
  },
  get DATA_LABEL_TITLE_TYPE_LIST() {
    return _DATA_LABEL_TITLE_TYPE_LIST;
  },
  get PIE_DATA_LABEL_POSITION_TYPE_LIST() {
    return _PIE_DATA_LABEL_POSITION_TYPE_LIST;
  },
  get LINE_DATA_LABEL_POSITION_TYPE_LIST() {
    return _LINE_DATA_LABEL_POSITION_TYPE_LIST;
  },
  get BAR_DATA_LABEL_POSITION_TYPE_LIST() {
    return _BAR_DATA_LABEL_POSITION_TYPE_LIST;
  },
  get COMBO_DATA_LABEL_POSITION_TYPE_LIST() {
    return _COMBO_DATA_LABEL_POSITION_TYPE_LIST;
  },
  get SUMMARY_DATA_LABEL_POSITION_TYPE_LIST() {
    return _SUMMARY_DATA_LABEL_POSITION_TYPE_LIST;
  },
  get LEGEND_POSITION_TYPE_LIST() {
    return _LEGEND_POSITION_TYPE_LIST;
  },
  get SLICER_TYPE_LIST() {
    return _SLICER_TYPE_LIST;
  },
  get FIELD_AGGREGATE_TYPE() {
    return _FIELD_AGGREGATE_TYPE;
  },
  get ALIGN_TYPE_LIST() {
    return _ALIGN_TYPE_LIST;
  },
  get SPACING_TYPE_LIST() {
    return _SPACING_TYPE_LIST;
  },
  get GRIDLINES_STROKE_TYPE_OPTIONS() {
    return _GRIDLINES_STROKE_TYPE_OPTIONS;
  },
  get STROKE_TYPE_OPTIONS() {
    return _STROKE_TYPE_OPTIONS;
  },
  get STROKE_HEAD_TYPE_OPTIONS() {
    return _STROKE_HEAD_TYPE_OPTIONS;
  },
  get SCATTER_SYMBOL_OPTIONS() {
    return _SCATTER_SYMBOL_OPTIONS;
  },
  get ORIENTATION_TYPE_OPTIONS() {
    return _ORIENTATION_TYPE_OPTIONS;
  },
  get SHAPE_TYPE_OPTIONS() {
    return _SHAPE_TYPE_OPTIONS;
  },
  get OPERATOR_TYPE_OPTIONS() {
    return _OPERATOR_TYPE_OPTIONS;
  },
  get CHART_INFO_LIST() {
    return _CHART_INFO_LIST;
  },
  get HAS_SECONDARY_VALUE_CHART_TYPE() {
    return _HAS_SECONDARY_VALUE_CHART_TYPE;
  },
  get NO_LEGEND_CHART_TYPE() {
    return _NO_LEGEND_CHART_TYPE;
  },
  get COLUMN_CHART_TYPES() {
    return _COLUMN_CHART_TYPES;
  },
  get BAR_CHART_TYPES() {
    return _BAR_CHART_TYPES;
  },
  get LINE_CHART_TYPES() {
    return _LINE_CHART_TYPES;
  },
  get OTHER_CHART_TYPES() {
    return _OTHER_CHART_TYPES;
  },
  get NO_DATA_LABEL_CHARTS() {
    return _NO_DATA_LABEL_CHARTS;
  },
  get IMAGE_FILL_OPTIONS() {
    return _IMAGE_FILL_OPTIONS;
  },
  get GRADIENT_TYPE_LIST() {
    return _GRADIENT_TYPE_LIST;
  },
  get GRADIENT_ROTATE_TYPE_LIST() {
    return _GRADIENT_ROTATE_TYPE_LIST;
  },
  get PIE_CHART_TYPES() {
    return _PIE_CHART_TYPES;
  },
  get LEGEND_MARKER_TYPE_OPTIONS() {
    return _LEGEND_MARKER_TYPE_OPTIONS;
  },
  get CHART_STYLE_APPLY_OPTIONS() {
    return _CHART_STYLE_APPLY_OPTIONS;
  },
  get LINE_TYPE_OPTIONS() {
    return _LINE_TYPE_OPTIONS;
  },
  get NUMBER_SCALE_TYPE_OPTIONS() {
    return _NUMBER_SCALE_TYPE_OPTIONS;
  },
  get UNIT_FORMAT_TYPE_OPTIONS() {
    return _UNIT_FORMAT_TYPE_OPTIONS;
  },
  get CELL_MERGE_TYPE_OPTIONS() {
    return _CELL_MERGE_TYPE_OPTIONS;
  },
  get TABLE_STYLE_APPLY_OPTIONS() {
    return _TABLE_STYLE_APPLY_OPTIONS;
  },
  get RELATIVE_DATE_TYPE_OPTIONS() {
    return _RELATIVE_DATE_TYPE_OPTIONS;
  },
  get CHART_MIN_SIZE() {
    return _CHART_MIN_SIZE;
  },
  get ALL_OPTION() {
    return _ALL_OPTION;
  },
  get SELECTOR_ALL_VALUE() {
    return _SELECTOR_ALL_VALUE;
  },
};
